/**
 * Copyright 2021 Olympe S.A.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Brick, registerBrick, WorkflowObjectState, Query, QueryResult } from 'olympe';
import { getLogger } from '@olympeio/core';
import { queryFilterByState } from './_workflow';

export default class WorkflowQueryFilterByState extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Query} objectsList
     * @param {WorkflowObjectState} state
     * @param {boolean} not
     * @param {function(QueryResult)} setFilteredList
     */
    update($, [query, state, not], [setFilteredList]) {
        if (!(query instanceof Query)) {
            getLogger('WorkflowFilterListByState').error('The query has to be a Query object');
            return;
        }
        queryFilterByState(query, state, not)
            .observe($)
            .subscribe(queryResult => {
                setFilteredList(queryResult);
            });
    }
}

registerBrick('018171f3104f1bf61895', WorkflowQueryFilterByState);
